import React from "react";
import { stageTone, typeTone } from "../config/stages";
import { slaPresentation } from "../config/sla";

// A cell holding a primary line and a muted secondary line.
export const TwoLine = function (props) {
  return (
    <div className="tn-twoline">
      <span className="tn-twoline-top">{props.top || "—"}</span>
      {props.bottom ? (
        <span className={"tn-twoline-bottom" + (props.mono ? " tn-mono" : "")}>
          {props.bottom}
        </span>
      ) : null}
    </div>
  );
};

// `type_label` is DOA / In-Warranty / Out-of-Warranty. Anything else falls back
// to a neutral tint rather than crashing on a missing tone entry.
export const TypeBadge = function (props) {
  if (!props.value) return <span className="tn-dash">{"—"}</span>;
  const tone = typeTone(props.value);
  return (
    <span
      className="tn-badge"
      style={{ background: tone.bg, color: tone.fg }}
    >
      {props.value}
    </span>
  );
};

export const StageBadge = function (props) {
  if (!props.value) return <span className="tn-dash">{"—"}</span>;
  const tone = stageTone(props.value);
  return (
    <span
      className="tn-badge tn-badge-dot"
      style={{ background: tone.bg, color: tone.fg }}
    >
      <span className="tn-badge-dotmark" />
      {props.value}
    </span>
  );
};

/*
`sla_status` arrives as a bare enum; the label, icon and tint are composed here.
An undocumented value degrades to a dash.
*/
export const SlaFlag = function (props) {
  const preset = slaPresentation(props.value);
  if (!preset) return <span className="tn-dash">{"—"}</span>;
  return (
    <span className={"tn-sla tn-sla-" + preset.tone}>
      {preset.icon ? (
        <span className="tn-sla-icon" aria-hidden="true">
          {preset.icon}
        </span>
      ) : null}
      <span>
        {preset.label}
        {preset.detail ? (
          <span className="tn-sla-detail"> {"·"} {preset.detail}</span>
        ) : null}
      </span>
    </span>
  );
};

export default { TwoLine, TypeBadge, StageBadge, SlaFlag };
